import React, { useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Spinner from './spinner/Spinner';
import { axiosInstancev2 } from '../utils/Axios/axiosInterceptorv2';
import useFetchDatav2 from '../hooks/useFetchDatav2';

function StudentCohortTransfer({ studentId, cohortId, toggleModal }) {
  const [error, setError] = useState('');
  const [selectedCohortId, setSelectedCohortId] = useState(cohortId);
  const queryClient = useQueryClient();

  const { data: cohortsData } = useFetchDatav2(
    ['cohorts-for-primary-cohort'],
    `/cohorts?limit=200`,
    {},
    '',
    true,
    true
  );
  const { cohorts = [] } = cohortsData?.data ?? {};

  const mutation = useMutation(
    (id) =>
      axiosInstancev2.post(
        `/users/students/${studentId}/memberships/transfer`,
        { cohortId: id, deactivatePrevious: false }
      ),
    {
      onSuccess: (res) => {
        toast.success(
          res?.data?.message || 'Student Transferred to new cohort'
        );
        queryClient.invalidateQueries(['intel-student']);
        toggleModal();
      },
      onError: (err) => {
        toast.error(err?.response?.data?.error || 'Failed to transfer cohort');
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCohortId) {
      setError('Please select a cohort');
      return;
    }
    mutation.mutate(selectedCohortId);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col space-y-1">
        <label htmlFor="activeCohort" className="text-base font-medium">
          Cohort
        </label>
        <select
          id="activeCohort"
          value={selectedCohortId}
          onChange={(e) => {
            setError('');
            setSelectedCohortId(e.target.value);
          }}
          className={`border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-persian-500 ${
            error ? 'border-claret-500' : 'border-gray-300'
          }`}
        >
          <option value="">Select a cohort</option>
          {cohorts.map((cohort) => (
            <option key={cohort.id} value={cohort.id}>
              {cohort.name}
              {cohort.status ? ` (${cohort.status})` : ''}
              {cohortId === cohort.id ? ' — current' : ''}
            </option>
          ))}
        </select>
        {error && <p className="text-claret-500 text-xs">{error}</p>}
      </div>

      {mutation.isLoading ? (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      ) : (
        <div className="flex justify-between mt-6">
          <button
            type="button"
            onClick={toggleModal}
            className="border border-claret-500 px-4 py-2 rounded-md text-claret-500 text-sm flex items-center space-x-2"
          >
            <CancelIcon fontSize="inherit" />
            <span>Cancel</span>
          </button>
          <button
            type="submit"
            disabled={selectedCohortId === cohortId}
            className="bg-claret-500 px-4 py-2 rounded-md text-white text-sm flex items-center space-x-2 disabled:opacity-60"
          >
            <SaveIcon fontSize="inherit" />
            <span>Confirm</span>
          </button>
        </div>
      )}
    </form>
  );
}

export default StudentCohortTransfer;
